// this file was prevaled
module.exports={"name":"soapbox","displayName":"Soapbox","url":"https://gitlab.com/soapbox-pub/soapbox","repository":"soapbox-pub/soapbox","version":"3.0.0-a0d595c","homepage":"https://soapbox.pub/"};